import React, { useContext, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Navigate, useParams } from 'react-router-dom'
import TimelineProvider from '../../../../contexts/TimelineContext'
import TimelineContent from './TimelineParts/TimelineContent'
import CampaignScenario from '../../../../models/CampaignScenario'
import { SharedCampaignContext } from '../../../../contexts/Advertiser/SharedCampaignContext'
import { useSidebarCollapse } from '../../../../contexts/SidebarCollapseContext'
import {
  advertiserShareFallbackPath,
  isProjectTimelineShared,
} from '../shareScenarioVisibility'

export default observer(function ProjectTimeline() {
  const { campaignScenarios, isLoading, campaign } = useContext(SharedCampaignContext)
  const { isCollapsed } = useSidebarCollapse()
  const { id } = useParams()

  const primaryScenario = campaignScenarios[0]
  const campaignScenario = useMemo(() => primaryScenario || new CampaignScenario(), [primaryScenario])

  if (!isLoading && !isProjectTimelineShared(primaryScenario)) {
    return (
      <Navigate
        to={`/advertiser/campaign_share/${id}/${advertiserShareFallbackPath({ scenario: primaryScenario, campaign })}`}
        replace
      />
    )
  }

  const leftOffset = isCollapsed ? 64 : 224

  return (
    <div
      className="fixed top-[52px] -z-10 h-[calc(100vh-52px)] bg-rb-grey transition-all duration-300 dark:bg-rb-dark-mode-background"
      style={{ left: `${leftOffset}px`, width: `calc(100vw - ${leftOffset}px)` }}
    >
      <TimelineProvider campaignScenario={campaignScenario} readonly layout="page">
        <TimelineContent />
      </TimelineProvider>
    </div>
  )
})
